<template>
  <GreenOperation />
</template>

<script>
import GreenOperation from '../greenOperation/GreenOperation'

export default {
  components: {
    GreenOperation,
  },
}
</script>

<style lang="scss" scoped>

</style>
